module.exports = __webpack_public_path__ + "img/high-fi-prototype-1.e72fc2fe.gif";